import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Form from 'react-jsonschema-form';
import { Button, ButtonGroup } from 'react-bootstrap';
import { step1Schema, newLoginSchema, uiSchema } from './Schema';

const SAVE_SUBMIT_TYPE = 'save';
const TEST_SUBMIT_TYPE = 'test';

export default class LoginEditor extends PureComponent {
  // hack used to track which submit button was pressed
  // eslint-disable-next-line react/sort-comp
  submitType = null;

  componentWillUnmount() {
    this.props.resetLoginVerification();
  }

  onSubmit = ({ formData }) => {
    if (this.submitType === SAVE_SUBMIT_TYPE) {
      return this.props.onSave(formData);
    }
    if (formData.id) {
      // If login save successful, verify with get request.
      return this.props.verifyLogin({ loginId: formData.id });
    }

    return this.props.verifyLogin({ login: formData });
  };

  render() {
    const { fetching, isNewLogin, login, dealerId, crmType } = this.props;
    const schema = isNewLogin ? newLoginSchema : step1Schema;
    const saveButtonName = isNewLogin ? 'Submit' : 'Save';
    return (
      <div className="login-list-container">
        <Form
          schema={schema}
          uiSchema={uiSchema}
          formData={login}
          onSubmit={this.onSubmit}
          enctype="multipart/form-data"
        >
          <p>
            <b>MFA email:</b>
            <p>
              mfa-{crmType}+{dealerId}@upstart.com
            </p>
          </p>
          <ButtonGroup>
            <Button
              bsClass="btn btn-primary btn-large"
              disabled={fetching}
              type="submit"
              onClick={() => {
                this.submitType = SAVE_SUBMIT_TYPE;
              }}
            >
              {saveButtonName}
            </Button>
            <Button
              bsClass="btn btn-large"
              title="Test CRM Login"
              type="submit"
              onClick={() => {
                this.submitType = TEST_SUBMIT_TYPE;
              }}
            >
              Test
            </Button>
          </ButtonGroup>
        </Form>
      </div>
    );
  }
}

LoginEditor.propTypes = {
  dealerId: PropTypes.string,
  fetching: PropTypes.bool,
  login: PropTypes.object,
  isNewLogin: PropTypes.bool,
  onSave: PropTypes.func,
  verifyLogin: PropTypes.func,
  resetLoginVerification: PropTypes.func,
  crmType: PropTypes.string,
};
